import React from "react";
import {
  getPaddingFondoTexto,
  replaceTextLinks,
  textBackgroundsOptions,
} from "../../constructor/umas/Actividades/ActividadesUtils/ActividadesUtils";
import { MathContent } from "../../utils/NimbusMath";
import HtmlBlockRenderer from "../../constructor/umas/ActividadesUtils/HtmlBlockRenderer";

function parseFondoBackground(background) {
  try {
    const parsed = JSON.parse(background);
    if (parsed?._type === "fondo") return parsed;
  } catch {}
  return null;
}

const Texto = ({
  texto,
  _id,
  background,
  backgroundObj,
  isHtml = false,
  captureHtmlAsImage = false,
}) => {
  const foundBackground =
    backgroundObj ??
    parseFondoBackground(background) ??
    textBackgroundsOptions?.find((el) => el.name === background);

  return (
    <div
      className="my-10"
    >
      {foundBackground?.header && (
        <img
          src={foundBackground?.header}
          className="w-full h-auto relative top-[13px] rounded-tl-md rounded-tr-md"
        />
      )}
      <div
        className={`w-full ${
          foundBackground?.header ? "" : "rounded-tl-md rounded-tr-md"
        } ${
          foundBackground?.footer ? "" : "rounded-bl-md rounded-br-md"
        } ${background}`}
        style={{
          backgroundImage: foundBackground
            ? `url(${foundBackground?.path})`
            : undefined,
          backgroundSize: "100%",
          padding: getPaddingFondoTexto(background, foundBackground),
        }}
      >
        {texto !== "" && (isHtml ? (
          <HtmlBlockRenderer html={texto} captureAsImage={captureHtmlAsImage} />
        ) : (
          <MathContent
            html={replaceTextLinks(texto)}
            className="p-2 justify-center visor"
          />
        ))}
      </div>
      {foundBackground?.footer && (
        <img
          src={foundBackground?.footer}
          className="w-full h-auto relative rounded-bl-md rounded-br-md"
        />
      )}
    </div>
  );
};

export default Texto;
